const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Image select", "uipress-lite"),
  moduleName: "uip-image-select-input",
  description: __("Outputs a image select input", "uipress-lite"),
  group: "form",
  icon: "image",
};
